/*
 * View for the reviewing the selected KB settings as the last step of the KB wizard
 */

define(["marionette", "./template/kbReviewTemplate.html"], function (Marionette, KbReviewTemplate) {
  var KbReviewView = {
    kbReviewLayout: Marionette.Layout.extend({
      template: KbReviewTemplate,
    }),
  };
  return KbReviewView;
});
